module.exports = __webpack_public_path__ + "static/media/bird_fly_page9_01.6cdf4f00.gif";